<xpo-footer [version]="buildVersion" class="footer">
  <div class="footer__actions">
    <a xpo-regular-link color="accent" (click)="openHelpLink()" data-test="footer__help">Help</a>
    <a xpo-regular-link color="accent" [href]="getDefaultMailLink()" data-test="footer__feedback">Feedback</a>
    <a xpo-regular-link color="accent" (click)="releaseNotes.emit()" data-test="footer__release-notes">Release Notes</a>
  </div>
</xpo-footer>
